import type {
  CalendarDay,
  CalendarEvent,
} from '@/components/Calendar/Calendar';
import type { EmployeeSchedules } from '@/schemas/API/GET/employee/schedule/response';
import type { TaskType } from '@/pages/Employees/Employee/Modals/TaskDetailModal';

export function employeeScheduleToCalendarDays(
  schedule: EmployeeSchedules,
  onTaskClick: (task: TaskType) => void
): CalendarDay[] {
  const calendarSchedule: CalendarDay[] = [];

  schedule.days.forEach(day => {
    const events: CalendarEvent[] = [];

    day.avail.forEach(event => {
      events.push({
        start: event.startTime,
        end: event.endTime,
        label: '',
        tooltip: '',
        color: 'green',
        onClick: () => console.log('availability handler here'),
      });
    });

    day.tasks.forEach(event => {
      events.push({
        start: event.boundStartTime,
        end: event.boundEndTime,
        label: event.name,
        tooltip: event.note ?? `${event.start} - ${event.start}`,
        color: 'blue',
        onClick: () => onTaskClick(event),
      });
    });

    day.excEvents.forEach(event => {
      events.push({
        start: event.startTime,
        end: event.endTime,
        label: event.name,
        tooltip: event.note,
        color: 'orange',
        onClick: () => console.log('exc event handler here'),
      });
    });

    day.abs.forEach(event => {
      events.push({
        start: '00:00:00',
        end: '23:59:59',
        label: event.name,
        tooltip: event.note ?? `${event.start} - ${event.end}`,
        color: 'red',
        onClick: () => console.log('absence handler here'),
      });
    });

    calendarSchedule.push({
      date: day.date,
      events,
    });
  });

  return calendarSchedule;
}
